const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Could not read this photo')); };
  img.src = url;
});

const toBlob = (canvas, quality) => new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));

// Resizes/re-encodes a photo as JPEG until it fits under maxBytes; non-images and small files pass through.
export async function shrinkImage(file, maxBytes) {
  const shrinkable = /^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type) || (!file.type && /\.(heic|heif)$/i.test(file.name));
  if (!shrinkable || file.size <= maxBytes) return file;
  const img = await loadImage(file);
  let scale = Math.min(1, 2000 / Math.max(img.naturalWidth, img.naturalHeight));
  const canvas = document.createElement('canvas');
  for (let attempt = 0; attempt < 8; attempt += 1) {
    canvas.width = Math.round(img.naturalWidth * scale);
    canvas.height = Math.round(img.naturalHeight * scale);
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const blob = await toBlob(canvas, attempt < 3 ? 0.85 - attempt * 0.1 : 0.7);
    if (blob && blob.size <= maxBytes) {
      const name = (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
      return new File([blob], name, { type: 'image/jpeg' });
    }
    if (attempt >= 2) scale *= 0.8;
  }
  throw new Error('This photo is too large even after shrinking');
}
